if (!customElements.get('show-hide-filters')) {
  customElements.define(
      'show-hide-filters',
      class ShowHideFilters extends HTMLElement {
        filtersBlock = document.querySelector('.facets-wrapper .facets-container');
        parentDiv = this.filtersBlock.closest('.facets-wrapper');

        constructor() {
          super();
          const button = this.querySelector('button');
          this.filtersBlock.classList.add('facets-wrapper--no-filters');

          button.addEventListener('click', (event) => {
            this.showHideLabel(event);
          });

          const showLabel = this.querySelector('.label-show');
          showLabel.addEventListener('click', (event) => {
            this.showFilters(event);
          });

          const hideLabel = this.querySelector('.label-hide');
          hideLabel.addEventListener('click', (event) => {
            this.hideFilters(event);
          });
        }
        showHideLabel() {
          this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        }

        showFilters() {
          this.filtersBlock.classList.remove('facets-wrapper--no-filters');
          this.parentDiv.classList.add('facets-wrapper--open');
        }

        hideFilters() {
          this.filtersBlock.classList.add('facets-wrapper--no-filters');
          this.parentDiv.classList.remove('facets-wrapper--open');
        }
      }
  );
}
